import React, { useState, useContext } from "react";

import { Link } from "react-router-dom";
import "../pages/Collection.css";
import { PostContext } from "../context/PostContext";
import { LanguageContext } from "../LanguageContext"; // Import the LanguageContext

import SEO from "../components/SEO"; // Centralized SEO Component
const Collection = () => {
  const { language } = useContext(LanguageContext); // Get the selected language
  const { pos } = useContext(PostContext); // Get posts from context
  const [sortOrder, setSortOrder] = useState("latest");

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  // Sort posts based on the selected sort order
  const sortedPosts = [...pos].sort((a, b) =>
    sortOrder === "latest" ? b.id - a.id : a.id - b.id
  );
  // ✅ **SEO Meta Data for Collection Page**
  const metaTitle = "500+ Snapseed QR Codes Collection - Free Editing Presets & Filters";
  const metaDescription = "Explore a collection of 100+ Snapseed QR codes for free. Get stunning DSLR photo editing presets, filters, and effects for your photos.";
  const metaUrl = "https://www.snapseedqrcodes.download/collection";
  const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

  // ✅ **Schema Markup for Google SEO**
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "headline": metaTitle,
    "description": metaDescription,
    "url": metaUrl,
    "image": metaImage,
    "publisher": {
      "@type": "Organization",
      "name": "Snapseed QR Codes",
      "logo": metaImage
    }
  };
  return (
    <div className="blog-page">

        {/* Use the SEO Component */}
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={schemaMarkup}
      />

    
      <h2 className="headingblog">Unlock 500+ Snapseed QR Codes to Enhance Your Photos – Discover the Best Presets!</h2>

      {/* Dropdown for Sorting */}
      <div className="sort-dropdown">
        <label htmlFor="sortOrder">Sort By: </label>
        <select
          id="sortOrder"
          value={sortOrder}
          onChange={(e) => setSortOrder(e.target.value)}
        >
          <option value="latest">Latest First</option>
          <option value="oldest">Oldest First</option>
        </select>
      </div>

      <div className="blog-container">
        {sortedPosts.map((post) => {

          
          // ✅ Extract the correct title & excerpt based on the selected language
          const postTitle = post.title?.[language] || post.title?.en || "Untitled";
          const postExcerpt = post.excerpt?.[language] || post.excerpt?.en || "No description available";

          return (
            <Link
              to={`/collection/${post.title?.en.toLowerCase().trim().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}/${post.id}`}
              key={post.id}
              className="blog-post-link"
              onClick={handleClick}
            >
              <div className="blog-post">
                <img src={post.image} alt={postTitle} className="post-image" />
                <h2 className="post-title">
                  {postTitle}
                  </h2>
                <p className="post-excerpt">
                  {postExcerpt} 
                  </p>
                <span className="read-more">Read More</span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Collection;
